module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-00.1.9f5f0ca9.jpg";